module.exports = __webpack_public_path__ + "img/grey_020.15812367.png";